import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function AdminLogin() {
  usePageMeta("Admin Sign In");
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) { toast.success("Welcome back."); navigate("/admin"); }
    else { setError(res.error); toast.error(res.error); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-navy px-5">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl">
        <div className="text-center">
          <img src="/lion-logo.webp" alt="" className="mx-auto h-14 w-14 object-contain" />
          <h1 className="mt-4 font-display text-3xl text-navy font-semibold">Ministry Admin</h1>
          <p className="mt-1 text-sm text-muted-foreground">Sign in to manage the site</p>
        </div>
        <form onSubmit={submit} className="mt-8 grid gap-4" data-testid="admin-login-form">
          <div className="grid gap-1.5">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="bg-white border-border focus-visible:ring-emerald" data-testid="admin-email" />
          </div>
          <div className="grid gap-1.5">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="bg-white border-border focus-visible:ring-emerald" data-testid="admin-password" />
          </div>
          <Button type="submit" disabled={loading} className="mt-2 rounded-full bg-emerald hover:bg-emerald-dark text-white py-6" data-testid="admin-login-submit">
            <Lock className="mr-2 h-4 w-4" /> {loading ? "Signing in…" : "Sign In"}
          </Button>
          {error && <p className="text-sm text-ruby text-center" role="alert" data-testid="admin-login-error">{error}</p>}
        </form>
      </div>
    </div>
  );
}
